import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/common/auth'

import Template from '@/template/index'
import Home from '@/views/home'
import ImprimePedidoPix from '@/views/pedido/imprimepedidopix'
import Authorized from '@/views/authorized'
import AcessoNegado from '@/views/acessonegado'
import Pedido from '@/views/pedido'
import cnastore from '@/views/cnastore'
import routersgenerated from './generated'

Vue.use(Router)

let childrens = routersgenerated.concat([
    {
        path: 'home',
        name: 'Home',
        component: Home
    },
    {
        path: '/pedido',
        name: 'Pedido',
        component: Pedido,
    },
    {
        path: '/cnastore',
        name: 'cnastore',
        component: cnastore,
    },
    {
        path: '/imprimepedidopix',
        name: 'imprimepedidopix',
        component: ImprimePedidoPix,
    },

    

]);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/authorized',
            name: 'authorized',
            component: Authorized,
        },
        {
            path: '/acessonegado',
            name: 'acessonegado',
            component: AcessoNegado,
        },
        {
            path: '/',
            redirect: '/home',
            component: Template,
            meta: { requiresAuth: true },
            children: childrens
        },
        {
            path: '*',
            redirect: '/home',
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!Auth.logged()) {
            Auth.login(true);
            return;
        }

        if (!Auth.canAccess(to.path)) {
            next('/acessonegado')
            return;
        }
    }
    next();
});


export default router;
